import { render, staticRenderFns } from "./staff.vue?vue&type=template&id=ecae5258&scoped=true&"
import script from "./staff.vue?vue&type=script&lang=ts&"
export * from "./staff.vue?vue&type=script&lang=ts&"
import style0 from "./staff.vue?vue&type=style&index=0&id=ecae5258&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecae5258",
  null
  
)

export default component.exports